import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type RelocationRecord = NonNullable<
  ResultOf<typeof relocationRecordQuery>["relocation"]
>;
export const relocationRecordQuery = graphql(`
  query RelocationRecord($id: ID!) {
    relocation(id: $id) {
      ...RelocationFields
    }
  }
`);

graphql(`
  fragment RelocationFields on Relocation {
    id
    created_at
    updated_at
    reference
    customer_url

    is_linked
    linkedRelocationCount
    workOrdersCount

    available_from_date
    available_to_date
    fixed_latest_departure_date

    open_departure_dates
    open_delivery_dates

    bookedBookingsCount

    departure_dates {
      date
      ranges {
        start
        end
      }
    }

    ogImage {
      ...MediaFields
    }

    trip {
      id
      square_image {
        ...MediaFields
      }
      cityA {
        id
        name
      }
      cityB {
        id
        name
      }
    }

    status
    type
    count
    quantity
    booked_count
    priority

    deal_score
    deal_rated_at

    measurement
    currency

    hire_unit_rate
    hire_unit_type
    hire_units_allowed
    minimum_hire_units
    extra_hire_unit_rate
    extra_hire_units_allowed
    extra_hire_unit_deposit_rate
    extra_hire_unit_supplier_net_rate
    retail_rate
    discount_percent
    holding_deposit_amount
    holding_deposit_refunded_at
    holding_deposit_refunded_by
    charge_per_move_amount
    booking_fee_amount
    distance_allowed
    excess_distance_rate
    extra_distance_allowed_per_extra_hire_unit
    is_ferry_required

    createdBy {
      ...UserFields
    }

    supplier {
      ...SupplierFields
      ...SupplierIconFields

      termsAndConditions {
        pdf_url
        type
      }
    }
    supplierInsuranceOption {
      ...SupplierInsuranceOptionRecordFields
    }

    promotion {
      id
      channels {
        id
        platform
        status
      }
    }

    vehicle {
      id
      name
      code
      hire_unit_type
      hire_unit_rate
      transmission
      child_seat_anchor_points
      type
      brand
      model
      approximate_age
      sleeps
      seatbelts
      type
      fuel
      has_heating
      has_kitchen
      has_shower_and_toilet
      is_self_contained
      is_pet_friendly
      pet_cleaning_fee

      minimum_age
      minimum_no_surcharge_age
      maximum_age
      maximum_no_surcharge_age
      has_age_surcharge

      heroImage
      created_at
      updated_at
      images {
        ...MediaFields
      }
    }
    departureOffice {
      id
      name
      code
      address {
        ...AddressFields
      }
    }
    deliveryOffice {
      id
      name
      code
      address {
        ...AddressFields
      }
    }
    deliveryCity {
      id
      name
      slug
      region
      state
    }
    departureCity {
      id
      name
      slug
      region
      state
    }
    inclusions {
      ...RelocationInclusionFields
    }

    acknowledgements {
      id
      name
      acknowledgement
    }

    group {
      id
      expires_at
      relocations {
        id
        status
        deliveryOffice {
          id
          name
        }
      }
    }

    lines {
      id
      sold_at
      sold_by
      reference
      booking {
        id
        reference
      }
    }

    stats {
      views_today
      views_yesterday
      views_total
      days_until_expiry
      bookings_count
      pending_bookings_count
      confirmed_bookings_count
      completed_bookings_count
    }

    workOrders {
      id
      reference
      status
      number_of_drivers
      currentQuote {
        id
        reference
      }
      currentInvoice {
        id
        reference
        status
      }
      assignments {
        id
        status
        proDriver {
          id
          name
        }
      }
    }
  }
`);
